<template>
  <div>
    <!-- <b-button @click="$bvToast.show('cookie-toast')">Show toast</b-button> -->
    <!-- <b-toast id="cookie-toast" variant="warning" :auto-hide-delay="msgHideDelay"
      solid static>
      <template #toast-title>
        <div class="d-flex flex-grow-1 align-items-baseline">
          <b-img blank blank-color="#ff5555" class="mr-2" width="12" height="12"></b-img>
          <strong class="mr-auto">{{ msgTitle }}</strong>
        </div>
      </template>
      {{ msgBody }}
    </b-toast> -->
    <b-alert
      variant="danger"
      dismissible
      fade
      :show="showDismissibleAlert"
      @dismissed="showDismissibleAlert=false">
      {{ msgBody }}
    </b-alert>
  </div>
</template>

<script>
export default {
  name: 'gl-cookies-consent',
  version: '0.0.1',
  props: {
    cookieName: {
      type: String,
      default: '__cookiesUsage=1'
    },
    maxAgeSeconds: {
      type: Number,
      default: 60*60*24*30*6 // ~ 6 months, recommended by french DPA
    },
    msgTitle: {
      type: String,
      default: 'Cookies usage information'
    },
    msgBody: {
      type: String,
      default: 'We are using cookies!'
    },
    msgHideDelay: {
      type: Number,
      default: 5000 // milliseconds
    },
  }, // props
  components: {}, // components
  data () {
    return {
      hasCookie: false,
      showDismissibleAlert: false
    }
  }, // data
  /* ----- vuejs hooks ----- */
  created () {
    this.hasCookie = document.cookie.split('; ').find(e => e === this.cookieName)
    if (!this.hasCookie) {
      // document.cookie = '__geeklineUseCookies=1; max-age=30'
      document.cookie = `${this.cookieName}; max-age=${this.maxAgeSeconds}`
    }
  }, // created
  mounted () {
    if (!this.hasCookie) {
      // this.$bvToast.show('cookie-toast')
      this.showDismissibleAlert = true
    }
  }, // mounted
  computed: {}, // computed
  watch: {}, // watch
  methods: {} // methods
}
</script>

<style scoped>
@import '~bootstrap/dist/css/bootstrap.css';
</style>
